
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { productType } from '../utils/types';

import { cartState } from './Atoms';

export const useAddProduct = () => {
  const [cart, setCart] = useRecoilState<any>(cartState);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart))
  }, [cart]);

  return (product: productType) => {
    const index = cart.findIndex((item: productType) => item.slug === product.slug);

    if (index === -1) {
      return setCart([...cart, { ...product, qty: product.qty ? product.qty : 1 }]);
    }

    else {
      if(product.options){
        return setCart([...cart, { ...product, qty: product.qty ? product.qty : 1 }]);
      }

      else{
      const newCart = cart.map((item: productType, i: number) => {
        if (i === index) {
          return {
            ...item,
            qty: item.qty! + 1,
          }

        }

        return item;
      })

      setCart(newCart)
    }
  }
  }
}


export const useRemoveProduct = () => {
  const [cart, setCart] = useRecoilState<any>(cartState);

  return (product: productType) => {

    

    const index = cart.find((item: productType) => item.slug === product.slug);
    let newCart;

    if (index.qty! > 1) {
      newCart = cart.map((item: productType) => {
          if (item === index) {
            return {
              ...item,
              qty: item.qty! - 1,
            }
          } 

        return item;
      })
    }

    else {
      newCart = cart.filter((item: productType) => item.slug !== product.slug)
    }

    setCart(newCart)
  }
}

export const useClearCart = () => {
  const [_cart, setCart] = useRecoilState<any>(cartState);
  setCart([]);
}